var map = {
	"./error.svg": 141,
	"./info.svg": 142,
	"./success.svg": 143,
	"./warning.svg": 144
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 439;



//////////////////
// WEBPACK FOOTER
// ./src/packages/message/assets ^\.\/.*\.svg$
// module id = 439
// module chunks = 0